export const productCategory = [
    {
        id: 1,
        category: 'Newest First'
    },
    {
        id: 2,
        category: 'Old Items'
    },
]